import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL1;
}

export default Atol1PoiTileEntity;
